export enum KpnPortingStatus {
  APPROVED = 'APPROVED',
}
